module.exports = __webpack_public_path__ + "img/image_1.07d86a6c.png";